var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibraryMandibular1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 563,
    height: 140,
    viewBox: "0 0 563 140",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1001_125556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7225 91.339C30.7225 91.339 1.06613 105.376 0.138508 94.0884C-0.789119 82.8005 2.22913 19.8952 24.9075 20.3649C47.5859 20.8347 46.6167 25.4217 46.6167 25.4217L30.7225 91.339Z",
    fill: "url(#paint0_linear_1001_125556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.716 42.7198C516.716 42.7198 527.321 17.9058 543.824 30.7134C560.328 43.5211 566.655 99.8776 560.951 99.6703C555.247 99.4631 527.515 91.9332 525.48 86.8488C523.444 81.7645 516.716 42.7059 516.716 42.7059V42.7198Z",
    fill: "url(#paint1_linear_1001_125556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.639 53.9111C470.639 53.9111 474.516 19.937 495.311 23.8055C516.106 27.6741 517.74 37.8428 521.202 50.8577C524.663 63.8726 540.156 115.96 516.716 112.906C493.276 109.853 479.818 96.2303 479.818 96.2303L470.639 53.9111Z",
    fill: "url(#paint2_linear_1001_125556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.565 95.7606C80.565 95.7606 44.7891 117.88 32.8684 113.307C20.9477 108.734 27.358 51.369 36.842 34.5823C46.3259 17.7955 57.942 10.4729 70.7903 23.2944C83.6386 36.1159 89.4398 41.297 89.4398 41.297L80.5788 95.7606H80.565Z",
    fill: "url(#paint3_linear_1001_125556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.085 32.7445C404.085 32.7445 406.231 25.7397 419.066 17.4914C431.9 9.24308 428.854 -4.79422 448.113 1.61651C467.371 8.02725 471.04 31.8188 473.796 43.4245C476.551 55.0301 493.677 127.303 469.517 131.752C445.358 136.201 429.768 99.8776 419.675 94.6966C409.582 89.5155 409.582 84.9285 401.025 86.766C392.469 88.6036 404.085 32.7583 404.085 32.7583V32.7445Z",
    fill: "url(#paint4_linear_1001_125556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.063 32.1364C345.063 32.1364 349.037 18.707 359.739 18.403C370.441 18.0991 389.7 11.1771 399.488 17.3806C409.277 23.5841 415.078 36.7096 409.582 62.0347C404.085 87.3599 409.582 125.203 390.018 131.917C370.455 138.632 355.475 111.773 348.746 91.339C342.017 70.9048 345.077 32.1364 345.077 32.1364H345.063Z",
    fill: "url(#paint5_linear_1001_125556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.971 42.8165C149.971 42.8165 148.06 31.1555 138.576 25.8639C134.229 23.4323 129.965 20.8624 126.046 17.7814C119.498 12.628 108.366 7.70938 97.373 20.3651C80.2466 40.067 79.0282 63.5685 79.0282 101.715C79.0282 139.862 83.9155 138.328 87.5845 138.328C91.2535 138.328 111.135 127.344 121.533 114.523C131.931 101.701 136.209 110.557 145.693 89.5015C155.177 68.4456 149.971 42.8165 149.971 42.8165Z",
    fill: "url(#paint6_linear_1001_125556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.534 45.8697C147.534 45.8697 146.011 19.3287 171.999 20.5445C197.986 21.7604 204.493 15.6674 208.896 31.5284L216.649 60.8189C216.649 60.8189 206.556 139.986 174.145 139.986C174.145 139.986 157.627 139.848 153.654 102.005C149.68 64.1624 147.534 81.861 147.534 45.8559V45.8697Z",
    fill: "url(#paint7_linear_1001_125556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.353 44.281C209.297 42.0152 209.173 39.7631 208.993 37.4973C208.536 32.0537 208.896 19.2736 221.993 18.5552C238.663 17.6433 263.737 13.2083 270.313 18.5552C276.89 23.9021 279.022 28.3233 279.022 49.2273C279.022 49.2273 280.088 74.2485 277.803 85.6883C275.519 97.1282 272.667 103.207 272.141 110.71C271.532 119.4 259.292 138.328 249.213 138.328C249.213 138.328 228.418 134.667 225.206 115.752C221.993 96.838 211.443 68.4595 210.377 60.3632C209.713 55.3202 209.464 48.6055 209.367 44.281H209.353Z",
    fill: "url(#paint8_linear_1001_125556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.412 34.7893C278.412 34.7893 277.789 19.1216 296.951 16.8834C316.113 14.6452 341.602 12.0063 345.88 25.8363C350.158 39.6664 349.757 70.5872 343.845 86.0475C337.933 101.508 342.82 122.868 332.838 131.006C322.855 139.143 320.197 145.858 301.645 132.028C283.092 118.198 278.412 57.5723 278.412 34.7893Z",
    fill: "url(#paint9_linear_1001_125556)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.005 26.6986C410.261 24.1169 413.745 20.911 419.066 17.4914C423.586 14.586 426.137 10.9624 428.386 7.76714C432.522 1.89115 435.638 -2.53611 448.113 1.61651C465.729 7.48054 470.301 27.8873 473.062 40.2077C473.191 40.7856 473.317 41.3457 473.439 41.8856C476.59 32.5374 482.972 21.5103 495.311 23.8056C509.913 26.522 515.067 32.3446 518.041 40.0777C521.366 34.0496 530.742 20.5611 543.824 30.7139C560.328 43.5215 566.655 99.878 560.951 99.6708C556.355 99.5038 537.459 94.5832 529.226 90.0181C530.201 103.359 527.853 114.357 516.716 112.907C499.03 110.603 487.027 102.282 482.2 98.3352C482.69 115.229 479.962 129.828 469.517 131.752C453.048 134.785 440.56 118.87 431.082 106.79C426.657 101.15 422.887 96.3457 419.675 94.6966C416.1 92.8613 413.791 91.1006 411.92 89.6736C410.004 88.213 408.547 87.1019 406.66 86.6183L406.607 87.3259C405.114 107.459 403.646 127.24 390.018 131.918C370.455 138.632 355.475 111.774 348.746 91.3394C347.532 87.6534 346.637 83.3709 345.985 78.8271C345.376 81.4725 344.663 83.9082 343.845 86.0478C341.395 92.4543 340.8 99.8738 340.232 106.946C339.43 116.94 338.684 126.24 332.838 131.006C331.572 132.038 330.423 133.047 329.345 133.995C321.925 140.517 317.844 144.104 301.645 132.028C287.134 121.211 281.11 81.7672 279.174 54.1932C279.355 62.0817 279.453 77.4268 277.803 85.6886C276.821 90.6072 275.734 94.5348 274.772 98.0106C273.496 102.619 272.441 106.433 272.141 110.71C271.532 119.4 259.292 138.328 249.213 138.328C249.213 138.328 228.418 134.667 225.206 115.753C223.36 104.888 219.094 90.8996 215.595 79.4271L215.595 79.4269C215.12 77.8718 214.66 76.3629 214.222 74.9143C209.607 97.6715 197.841 139.987 174.145 139.987C174.145 139.987 157.627 139.849 153.654 102.006C152.08 87.0215 150.793 80.7453 149.813 76.3952C148.932 80.7843 147.614 85.2367 145.693 89.5016C140.05 102.029 136.25 103.968 131.908 106.184C128.952 107.693 125.744 109.33 121.533 114.523C111.135 127.344 91.2535 138.328 87.5845 138.328C87.4493 138.328 87.3125 138.33 87.1743 138.332C83.562 138.387 79.0282 138.456 79.0282 101.715C79.0282 100.009 79.0306 98.3315 79.0368 96.6827C72.0825 100.822 43.3151 117.315 32.8684 113.307C28.7094 111.712 26.7817 103.69 26.4374 93.2078C18.1875 96.603 0.844427 102.679 0.138508 94.0891C-0.789119 82.8012 2.22913 19.8959 24.9075 20.3656C37.2077 20.6204 42.5515 22.0864 44.8665 23.3747C52.6084 15.3225 61.368 13.8917 70.7903 23.2943C78.2391 30.7275 83.3192 35.5927 86.2736 38.3691C88.9097 31.8928 92.4965 25.9749 97.373 20.3651C108.366 7.7094 119.498 12.628 126.046 17.7814C129.965 20.8625 134.229 23.4323 138.576 25.8639C143.912 28.8408 146.85 33.8335 148.4 37.6317C150.215 29.9515 155.689 19.7822 171.999 20.5453C178.96 20.8709 184.523 20.6722 189.022 20.5115C201.321 20.0721 205.672 19.9167 208.896 31.5292L209.022 32.0043C209.615 26.1428 212.356 19.0841 221.994 18.5554C226.216 18.3244 230.979 17.8673 235.843 17.4004C250.18 16.0243 265.403 14.5631 270.313 18.5554C274.956 22.3304 277.384 25.644 278.41 34.6225C278.41 32.9351 278.954 18.9859 296.951 16.8836C316.113 14.6454 341.602 12.0065 345.88 25.8366C346.132 26.6504 346.367 27.5235 346.587 28.449C348.594 24.4494 352.719 18.6028 359.739 18.4034C363.041 18.3096 367.158 17.5859 371.559 16.812C381.424 15.0776 392.72 13.0915 399.489 17.381C402.924 19.5582 405.868 22.588 408.005 26.6986Z",
    fill: "url(#paint10_linear_1001_125556)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1001_125556",
    x1: 120.453,
    y1: 158.886,
    x2: -28.3826,
    y2: 158.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFBFBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DED4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#EAE4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F2F0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCBBB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1001_125556",
    x1: 613.341,
    y1: 144.324,
    x2: 516.425,
    y2: 144.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFBFBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DED4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#EAE4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F2F0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCBBB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1001_125556",
    x1: 582.189,
    y1: 124.346,
    x2: 477.658,
    y2: 124.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFBFBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DED4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#EAE4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F2F0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCBBB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1001_125556",
    x1: -47.0736,
    y1: 122.274,
    x2: 57.8818,
    y2: 144.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFBFBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DED4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#EAE4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F2F0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCBBB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1001_125556",
    x1: 565.575,
    y1: 131.517,
    x2: 413.278,
    y2: 131.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFBFBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DED4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#EAE4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F2F0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCBBB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1001_125556",
    x1: 344.842,
    y1: 69.8685,
    x2: 648.164,
    y2: 99.2806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFBFBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DED4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#EAE4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F2F0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCBBB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1001_125556",
    x1: 12.4607,
    y1: 116.057,
    x2: 115.189,
    y2: 144.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFBFBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DED4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#EAE4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F2F0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCBBB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1001_125556",
    x1: 53.9962,
    y1: 90.1231,
    x2: 242.971,
    y2: 113.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCBBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#D5C9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E0D9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E7E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCBBB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1001_125556",
    x1: 244.077,
    y1: 19.8125,
    x2: 244.077,
    y2: 144.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCBBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#D5C9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E0D9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E7E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCBBB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1001_125556",
    x1: 313.579,
    y1: 19.8125,
    x2: 313.579,
    y2: 144.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCBBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#D5C9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E0D9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E7E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCBBB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1001_125556",
    x1: 313.579,
    y1: 19.8127,
    x2: 313.579,
    y2: 144.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#E2DFDF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1001_125556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 563,
    height: 140,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryMandibular1);
export default __webpack_public_path__ + "static/media/library_mandibular1.1578ae3e559d6e625d17346929829b40.svg";
export { ForwardRef as ReactComponent };